import type { SVGProps } from 'react'
import { Ref, forwardRef } from 'react'
import { createIcon } from '../../create-icon'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgBell = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M13.6921 11.433C13.6921 11.433 13.6921 11.4327 13.6918 11.4324C13.6409 11.3501 13.5838 11.2722 13.5209 11.1987C12.9295 10.2188 13.3128 8.62599 13.5068 7.98195C13.5411 7.88927 13.573 7.79503 13.6018 7.69889C14.2531 5.52991 13.2812 3.23464 11.4012 2.24126C11.4436 2.17717 11.4776 2.10554 11.5011 2.02763C11.6262 1.61074 11.4042 1.16714 11.005 1.03645C10.6059 0.905758 10.1812 1.13761 10.056 1.5545C10.0326 1.63273 10.0214 1.71158 10.0211 1.7895C7.93451 1.4835 5.88157 2.78759 5.23035 4.95657C5.20568 5.03888 5.18342 5.1215 5.16327 5.20444C4.98189 5.8224 4.42391 7.41552 3.38044 7.87702C3.2887 7.89996 3.19906 7.9298 3.11243 7.96687C3.11243 7.96687 3.11213 7.96687 3.11183 7.96687C2.62965 8.17328 2.23591 8.59394 2.06776 9.15378C1.76787 10.1525 2.29998 11.2163 3.25621 11.5298L6.54363 12.6067C6.52257 13.6224 7.14041 14.5728 8.11529 14.892C9.09017 15.2115 10.1168 14.7999 10.6549 13.9536L11.6256 14.2715C12.5818 14.5847 13.6003 14.029 13.9005 13.0302C14.0687 12.4704 13.9751 11.8901 13.6924 11.433H13.6921Z" />
  </svg>
)
const ForwardRef = forwardRef(SvgBell)
const IconSvgBell = createIcon(ForwardRef, 'SvgBell')
export default IconSvgBell
